import { connect } from "react-redux";
import { deleteToken } from "./action/user";
import React, { useEffect } from 'react';
import { useNavigate } from "react-router";

const Logout = ({_deleteToken}) => {
    const navigate = useNavigate();
    useEffect(()=>{
        (async ()=>{
            _deleteToken();
            navigate('/');
        })();
    },[]);
    return <div></div>;
};

const mapDispatchToProps = (dispatch) => ({
    _deleteToken : () => dispatch(deleteToken())
});

export default connect(undefined, mapDispatchToProps)(Logout);
